// import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import FormInput from '../../../../components/FormInput'
import WrapperButton from '../../../../components/WrapperButton'
import { RootState } from '../../../../redux/store'
import { CityType, InputTypes } from '../../../../types/components'
import { Heading } from '../styles'
import { AddressWrapper } from './styles'
// import locationIcon from '../../../../asset/location.png'
// import { setErrorToast } from '../../../../helpers/errorStyles'
// import { setLoadingStatus } from '../../../../redux/slices/meta'
// import { setLocation } from '../../../../redux/slices/user'
// import { PlatFormTypes } from '../../../../types/state'

const City = ({ formValues, errors, handleForm, handleSubmit }: CityType) => {
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	// const userDetails = useSelector((state: RootState) => state.user)
	// const [showLocation, setShowLocation] = useState(true)
	// const dispatch = useDispatch()

	// useEffect(() => {
	// 	if (
	// 		metaData.platform === PlatFormTypes.ANDROID ||
	// 		metaData.platform === PlatFormTypes.IOS
	// 	) {
	// 		if (userDetails.latitude === null || userDetails.longitude === null) {
	// 			setShowLocation(false)
	// 		}
	// 	}
	// }, [metaData.platform, userDetails.latitude, userDetails.longitude])

	// useEffect(() => {
	// 	if (userDetails.latitude !== null && userDetails.longitude !== null) {
	// 		dispatch(setLoadingStatus(true))
	// 		fetch(
	// 			`https://maps.googleapis.com/maps/api/geocode/json?latlng=${userDetails.latitude},${userDetails.longitude}&key=${constantValues.googleKey}`
	// 		)
	// 			.then((res) => res.json())
	// 			.then((data) => {
	// 				if (data.status !== 'OK') {
	// 					dispatch(setLoadingStatus(false))
	// 					setErrorToast(
	// 						'Error Fetching Geo Location. Please Enter Manually.'
	// 					)
	// 					setShowLocation(false)
	// 				} else if (data.status === 'OVER_QUERY_LIMIT') {
	// 					dispatch(setLoadingStatus(false))
	// 					setErrorToast('Over Query Limit reached.')
	// 					setShowLocation(false)
	// 				} else {
	// 					let pin = ''
	// 					data.results.forEach((addressComp: any) => {
	// 						if (addressComp.types.includes('postal_code')) {
	// 							pin = addressComp.address_components[0].long_name
	// 						}
	// 					})
	// 					dispatch(setLoadingStatus(false))
	// 					updateFormData({
	// 						...formValues,
	// 						pincode: pin,
	// 					})
	// 				}
	// 			})
	// 	}
	// }, [userDetails.latitude, userDetails.longitude])

	// const posError = () => {
	// 	if (navigator.permissions) {
	// 		navigator.permissions.query({ name: 'geolocation' }).then((res) => {
	// 			if (res.state === 'denied') {
	// 				setErrorToast('You have not given the location permission')
	// 				setShowLocation(false)
	// 				dispatch(setLoadingStatus(false))
	// 			}
	// 		})
	// 	} else {
	// 		setErrorToast('Unable to access location')
	// 		dispatch(setLoadingStatus(false))
	// 		setShowLocation(false)
	// 	}
	// }

	// const getGeoLocation = () => {
	// 	dispatch(setLoadingStatus(true))
	// 	if (navigator.geolocation) {
	// 		navigator.geolocation.getCurrentPosition((pos) => {
	// 			dispatch(
	// 				setLocation({
	// 					latitude: pos.coords.latitude,
	// 					longitude: pos.coords.longitude,
	// 				})
	// 			)
	// 		}, posError)
	// 	} else {
	// 		setErrorToast('Unable to access location')
	// 		dispatch(setLoadingStatus(false))
	// 		setShowLocation(false)
	// 	}
	// }

	return (
		<AddressWrapper>
			<Heading>{translations.YOUR_CITY}</Heading>

			{/* {showLocation && (
				<>
					<LocationButton onClick={getGeoLocation}>
						<div style={{ marginRight: '10px' }}>
							<img src={locationIcon} alt="locationIcon" />
						</div>
						<div>{translations.CURRENT_LOCATION}</div>
					</LocationButton>

					<ORLine>
						<ORWord>OR</ORWord>
					</ORLine>
				</>
			)} */}

			<>
				<FormInput
					marginTop="inherit"
					type={InputTypes.TEXT}
					label={translations.CITY}
					value={formValues.city}
					name="city"
					handleChange={(e) => handleForm(e)}
					errorMessage={errors.city}
					// maxlength={6}
					autofocus={false}
					inputmode="text"
				/>
				<WrapperButton
					isLoading={metaData.isLoading}
					buttonClickHandler={handleSubmit}
					isEnabled={formValues.city?.length >= 3 ? true : false}
					btnText={translations.CONTINUE}
				/>
			</>
		</AddressWrapper>
	)
}

export default City
